import React from 'react';
import styled from 'styled-components'
import {CBtn} from '../Components/CBtn';
import ShowQuoC from '../Containers/ShowQuoC';
import AutorenewRoundedIcon from '@material-ui/icons/AutorenewRounded';
import { useState } from 'react';
import {addQuote, postQuote} from '../Actions/Quote_actions'
import { connect } from 'react-redux';
import { Link } from 'react-router-dom'
import AlertMsg from '../Components/AlertMsg';
import history from '../history'
import { useEffect } from 'react';
import NavBar from '../Components/NavBar';


const TITLE = styled.h2`
@media screen and (max-width: 48rem) {
    margin-top: 3rem
}
text-align: center;

`
const WRITE = styled.textarea`
max-width: 100%;
    border: none;
    outline: none;
    height: 10rem;
    font-size: 2rem;
    line-height: 2rem;
    margin-top: 3rem;
    background: white;
    padding: 1rem;
    width: 91.5%;

     
`
const SPAN = styled.span`
transition: ease-in-out 2s;
margin-left: .5rem;
&.disabled {
    opacity: .5;
    transition: ease-in-out 2s;
}
`
const SECTION = styled.section`
@media screen and (min-width: 48rem) {
display: flex;
flex-flow: column;
align-items: center;
justify-content: center;
border: silver;
 margin: 20vh auto auto auto;
width: 98%;
}
`

const Quotes = ({dispatch, quo}) => {

    const[write, setWrite] = useState('')
    const[nxtP, setNP] = useState('skip')
    const[monQuo, setMQ] = useState('')
    const[show, setShow] = useState(false)


    useEffect(() => {document.title = 'Quotes'})
   const handleDispatch = () => {
       if( write !== '' ) {
        dispatch(addQuote(write)) 
        setWrite('')
        setNP('continue')
       } else return ''
        
    }

    const handleMonDB_Quote = async () => {
        setNP(<AutorenewRoundedIcon />)
         try {
            if(quo.length > 0) {
                let ans = await postQuote(quo)
                 if(ans.error === 'you are not logged in') {
                     alert(ans.error)
                     setTimeout(() => history.push('/Iamwealthy/login'), 1100);
                 }
                if(ans === 'success') {
                    setMQ('success')
                    setNP('done')
         
                    setShow(true)
                    setTimeout(() => window.location.replace(`/dashboard`), 2000);
         
                }
                 else if(ans === 'Failed to fetch') {
                                setMQ('fail')
                                setNP('retry')
                                setShow(true)
         
                      }
            } else throw Error
            
        } 
        catch (error) {
            setNP('continue')
            setMQ('empty')
            setShow(true)
         }
         
      
    }

    const getSt = st => {
        if(st === true) setShow(false)
    }
    
    return ( 
        <>
        <NavBar
        fNav={'How To'} 
       fNavL='#howWealthme' 
       sNav='Home' 
       sNavL='/' />
         
<TITLE> What are your top Quotes / Financial commitments ? </TITLE>
 
 
{show ? <AlertMsg 
msg={monQuo === 'fail' ? 'An Error occured, pls check your network or retry, thanks' : monQuo === 'success' ?  'Your Quote was successfully saved, thanks' : 'Pls add some quotes to proceede, thanks'} 
getSt={getSt} 
action='Quote' 
 /> : ''}   
 

 
<SECTION>
<WRITE 
placeholder = 'write your favourite quote here...' 
onChange={ ({target}) => setWrite(target.value)} 
value={write}
></WRITE>
{nxtP === 'skip' ?
<>
<section style={{display: 'flex', background:'white', height:'10rem', justifyContent:'center', alignItems:'center'}}>

<span> <a href={`/wall/${sessionStorage.getItem('mail')}`} style={{textDecoration:'none', color:'darkslategray', marginLeft:'7rem',alignSelf:'center'}}> {nxtP} </a></span>
<SPAN 
onClick={handleDispatch} 
 
className={write === '' ? 'disabled' : 'no'} >
<CBtn name='Add quote' left='0rem' />
</SPAN>
</section>
</>

:
<>
<section style={{display: 'flex', background:'white', height:'10rem', justifyContent:'center', alignItems:'center'}}>

<span onClick={handleMonDB_Quote}> <Link to='#' style={{textDecoration:'none', color:'darkslategray', marginLeft:'7rem',marginRight:'.5rem'}}> {nxtP} </Link></span>
<SPAN 
onClick={handleDispatch} 
disabled={write === '' ? true : false}
className={write === '' ? 'disabled' : 'no'} >
<CBtn name='Add quote' left='0rem' />
</SPAN>
</section>
</>

}
   



 <ShowQuoC />

  
</SECTION>


        </>
     );
}
 
const mapStateToProps = ({Quote}) => ({ quo: Quote })

export default connect(mapStateToProps, null)(Quotes);